<template>
  <div>
      <button type="button" v-for="l in langs" :key="l.code" :class="['btn', selected == l.code ?  'btn-primary' :'btn-outline-primary' ]" @click="selected = l.code"> {{ l.label }} <slot name="badge" v-bind:badge="l" > </slot> </button>
  </div>
</template>
<script>
export default {
  name: 'lang-switcher',
  props: {
    value: {
      type: String,
      default: "it"
    },
    langs: {
      type: Array,
      default: [] ,
  }
  },
  data() {
    return {
      selected: "it"
    };
  },
  watch: {
    selected: function(newVal, oldVal) {
      if(newVal !== oldVal)
        this.$emit("input", newVal);
    }
  }
};
</script>
<style>
</style>
